import {
  set,
  get as dbGet,
  del,
  clear,
} from 'idb-keyval'

export default {
  set: async (key: string, val: any): Promise<any> => {
    try {
      await set(key, val)
      return Promise.resolve()
    } catch (err) {
      console.error('db set error: ', err)
      return Promise.reject(err)
    }
  },
  get: (key: string): Promise<any> => dbGet(key),
  del: (key: string): void => {
    del(key)
  },
  clear: (): void => {
    clear()
  },
}
